import { Box, Typography } from "@mui/material";
import "./IdeaMenu.scss";
import DataTable from "../../../../widgets/DataTable";
import { useEffect, useState } from "react";
import ideasServices from "../../../../services/ideasServices";

// interface HospitalArea {
//   hospital_area_id: number;
//   area_name: string;
//   hospital_unit_id: number;
//   hospital_unit_name: string;
// }

// interface HospitalUnit {
//   id: number;
//   name: string;
// }

// interface Autor {
//   id: number;
//   nombre: string;
// }

interface IdeaMenuProps {
  selectedIdea: any;
  updateContent?: (menu: string) => void;
}

// interface Idea {
//   idea_id: number;
//   titulo: string;
//   descripcion: string;
//   categoria: string;
//   recursos: string;
//   fecha_creacion: string;
//   autores: Autor[];
//   areas: Area[];
//   hospitales: Hospital[];
// }

export default function IdeaMenu({
  selectedIdea: idea,
  updateContent,
}: IdeaMenuProps) {
  const [areas, setAreas] = useState<any | null>(null);
  const [authors, setAuthors] = useState<any | null>(null);
  const [ideaChanges, setIdeaChanges] = useState<any | null>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let ideaId = idea.idea_id;

    ideasServices
      .getIdeaChanges(ideaId)
      .then((res) => {
        setIdeaChanges(res);
      })
      .catch((err) => {
        console.error("Error al obtener los cambios de la idea", err);
        setIdeaChanges([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    setAreas(idea.hospital_areas);
    setAuthors(idea.authors);
  }, [idea]);

  const ideasHeaders = [
    {
      name: "Fecha y hora",
      id: "created_at",
    },
    {
      name: "Responsable",
      id: "creator",
    },
    {
      name: "Tipo de acción",
      id: "change_type",
    },
    {
      name: "Valor original",
      id: "original_value",
    },
    {
      name: "Valor nuevo",
      id: "new_value",
    },
  ];

  return (
    <Box>
      <Box className="menu-content">
        <Box className="menu-content__idea">
          <Box className="menu-content__idea__params">
            <Box className="menu-content__idea__params__subtitle">
              <Typography>Área(s):</Typography>
            </Box>
            <Box className="menu-content__idea__params__info">
              <Box
                className="menu-content__idea__params__info__row"
                sx={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <Typography>
                  {areas?.map((a: any) => a.area_name).join(", ") || "-"}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box className="menu-content__idea__params">
            <Box className="menu-content__idea__params__subtitle">
              <Typography>Categoría:</Typography>
            </Box>
            <Box className="menu-content__idea__params__info">
              <Typography>{idea.category}</Typography>
            </Box>
          </Box>
          <Box className="menu-content__idea__params">
            <Box className="menu-content__idea__params__subtitle">
              <Typography>Autor(es):</Typography>
            </Box>
            <Box className="menu-content__idea__params__info">
              <Box
                className="menu-content__idea__params__info__row"
                sx={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <Typography>
                  {Array.isArray(authors)
                    ? authors
                        .map((a: any) => `${a.first_name} ${a.last_name}`)
                        .join(", ")
                    : authors || "-"}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box className="menu-content__idea__params">
            <Box className="menu-content__idea__params__subtitle">
              <Typography>Descripción:</Typography>
            </Box>
            <Box className="menu-content__idea__params__info">
              <Typography>{idea.description}</Typography>
            </Box>
          </Box>
          <Box className="menu-content__idea__params">
            <Box className="menu-content__idea__params__subtitle">
              <Typography>Recursos necesarios:</Typography>
            </Box>
            <Box className="menu-content__idea__params__info">
              <Typography>{idea.resources}</Typography>
            </Box>
          </Box>
        </Box>
        <Box className="menu-content__idea__params__subtitle">
          <Typography sx={{ marginBottom: "20px" }}>
            Historial de cambios
          </Typography>
        </Box>
        <Box className="menu-content__history">
          <DataTable
            rows={ideaChanges}
            headers={ideasHeaders}
            isLoading={isLoading}
            tableType="history"
          />
        </Box>
      </Box>
    </Box>
  );
}
